module.exports = __webpack_public_path__ + "static/media/logo.1fb0fe3d.png";